/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The inspection outcome
 */
export enum InspectionOutcome {
	CERTIFICATE = 'Certificate',
	NOTICE_WITH_MODIFICATIONS = 'Notice With Modifications',
	NOTICE = 'Notice',
}
